import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/send.png'


const _withScopeId = n => (_pushScopeId("data-v-0325889d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top_header" }
const _hoisted_2 = { class: "app-modal" }
const _hoisted_3 = { class: "app-modal-container" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "row",
    style: {"display":"flex","justify-content":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "aria-hidden": "true",
      role: "img",
      class: "iconify iconify--carbon",
      width: "32",
      height: "32",
      preserveAspectRatio: "xMidYMid meet",
      viewBox: "0 0 32 32"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        fill: "currentColor",
        d: "M12 4a5 5 0 1 1-5 5a5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7a7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7zm0-26h10v2H22zm0 5h10v2H22zm0 5h7v2h-7z"
      })
    ])
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-0325889d><div class=\"col-md-12\" data-v-0325889d><p class=\"title-modal\" data-v-0325889d><strong data-v-0325889d>Pour une analyse plus efficace !!!</strong></p><p class=\"modal-title-2\" data-v-0325889d> Pour des besoins liés à l&#39;enquête, nous pouvons avoir besoin de vous contactez. Pour cela veuillez bien nous fournir les informations ci-après </p></div></div><p class=\"info-red\" data-v-0325889d> Toutes les informations entrées seront traitées de manière sécurisée </p>", 2)
const _hoisted_8 = { class: "row modal-fisrtline app-modal-input" }
const _hoisted_9 = {
  class: "col-md-6",
  style: {"flex":"0 0 50%"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "organisme_label",
  style: {"font-size":"14px"}
}, "Nom", -1))
const _hoisted_11 = {
  class: "col-md-6",
  style: {"flex":"0 0 50%"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "organisme_label",
  style: {"font-size":"14px"}
}, "Prénom(s)", -1))
const _hoisted_13 = { class: "row modal-secondline app-modal-input" }
const _hoisted_14 = {
  class: "col-md-6",
  style: {"flex":"0 0 50%"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "organisme_label",
  style: {"font-size":"14px"}
}, " Numéro téléphone ", -1))
const _hoisted_16 = {
  class: "col-md-6",
  style: {"flex":"0 0 50%"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "organisme_label",
  style: {"font-size":"14px"}
}, "Email", -1))
const _hoisted_18 = { class: "header" }
const _hoisted_19 = { class: "footer" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Formulaire de dénonciation", -1))
const _hoisted_21 = { class: "contexte" }
const _hoisted_22 = { class: "plainte" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "plainte_label" }, "Complément d'information", -1))
const _hoisted_24 = { class: "plainte_text" }
const _hoisted_25 = {
  class: "plainte",
  style: {"margin-top":"40px"}
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "plainte_label" }, " Joindre des documents à votre plainte ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "plainte_button",
  type: "button",
  value: "Choisir le(s) fichier(s)"
}, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Formats acceptés : pdf, image, audio, vidéo", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "plainte_label list_image" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { style: {"margin-left":"10px","margin-top":"10px"} }
const _hoisted_33 = { style: {"background-color":"gray","padding":"10px","border-radius":"14px"} }
const _hoisted_34 = {
  class: "plainte",
  style: {"margin-top":"40px"}
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"40px","margin-top":"-31px","display":"block"} }, "ENVOYEZ VOTRE DÉNONCIATION", -1))
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Vous êtes protégés par la loi (Décret N°2022-040)", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderPage = _resolveComponent("HeaderPage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle(_ctx.show)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lastname) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.lastname]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.firstname) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.firstname]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "aria-label": "tel",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.phone) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.phone]
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  class: "form-control",
                  "aria-label": "email",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ])
              ])
            ])
          ])
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_HeaderPage),
      _createElementVNode("footer", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.description) = $event)),
                class: "plainte_input",
                rows: "15",
                cols: "50"
              }, "\n              ", 512), [
                [_vModelText, _ctx.description]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.chargerfile()))
            }, _hoisted_29),
            _createElementVNode("div", _hoisted_30, [
              (_ctx.progrss_allFile2.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, " Liste des documents joints : "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.progrss_allFile2, (file, index) => {
                return (_openBlock(), _createElementBlock("ul", {
                  key: file.name
                }, [
                  _createElementVNode("li", _hoisted_32, [
                    _createTextVNode(_toDisplayString(index + 1) + ". " + _toDisplayString(file.name) + " ", 1),
                    _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.filesUploadProgressbar[file.name]) + "% ", 1)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", {
              class: "plainte_send",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.submited && _ctx.submited(...args)))
            }, _hoisted_37),
            _hoisted_38
          ]),
          _createElementVNode("input", {
            ref: "fileInput",
            class: "real-file-input",
            type: "file",
            multiple: "",
            style: {"display":"none"},
            accept: "application/pdf, image/* audio/* video/*",
            onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onFileChanged && _ctx.onFileChanged(...args))),
            id: "getFile"
          }, null, 544)
        ])
      ])
    ])
  ]))
}